import React from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import companyLogo from '../../../assets/images/beebom-logo.png';
import { StyledText, FlexContainer } from '../StyledComponents';
import { mediaMax } from '../Media Template/Media Template';

const StyledLogo = styled.div.attrs({})`
  padding: 0 8px;
  height: 4rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  /* ${mediaMax.phone`
  padding: 0,
  `}; */
`;

const StyledImage = styled.img.attrs({})`
  /* height: 100%; */
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
`;

const logo = props => {
  const { children } = props;
  const goToHome = () => {
    props.history.push('/');
  };
  let content;
  if (children === 'Beebom') {
    content = (
      <StyledText
        className="StyledText dn flex-l items-center"
        width="95px"
        height="32px"
        fontfamily="Nunito"
        fontsize="1.5rem"
        fontweight="bold"
        color="#353535"
        padding="0 0 0 10px"
      >
        {children}
      </StyledText>
    );
  } else {
    content = <FlexContainer>{children}</FlexContainer>;
  }

  return (
    <StyledLogo className="StyledLogo pointer" onClick={goToHome}>
      <StyledImage
        className="StyledImage"
        src={companyLogo}
        alt="beebom-logo"
      />
      {content}
    </StyledLogo>
  );
};

export default withRouter(logo);
